(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gymatics-minimal-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gymatics-hero-buddy')) {
  customElements.define('gymatics-hero-buddy', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = true;
      this.activeAnimations = [];
      this.pause = this.querySelector('[data-hero-buddy-pause]');
      this.character = this.querySelector('[data-hero-buddy-character]');
      const layers = [...this.querySelectorAll('.gm-buddy-home__layer')];
      const ready = () => this.toggleAttribute('data-puppet-ready', layers.every(image => image.complete && image.naturalWidth > 0));
      layers.forEach(image => { image.addEventListener('load', ready, {signal}); image.addEventListener('error', ready, {signal}); });
      ready();
      this.refresh = () => {
        const enabled = this.dataset.motionEnabled !== 'false' && !this.reduced.matches;
        this.pause.hidden = !enabled;
        this.pause.textContent = this.paused ? 'Play animation' : 'Pause animation';
        this.pause.setAttribute('aria-pressed', String(this.paused));
        const running = enabled && !this.paused && this.visible && !document.hidden;
        this.toggleAttribute('data-running', running);
        if (!running) this.stopReaction();
      };
      this.pause.addEventListener('click', () => { this.paused = !this.paused; this.refresh(); }, {signal});
      this.character.addEventListener('click', () => {
        this.querySelector('[data-hero-buddy-greeting]').textContent = 'Hello from Buddy!';
        const tip = this.closest('.gm-buddy-home').querySelector('[data-hero-buddy-tip]');
        if (tip) tip.textContent = 'Hello! Nice to meet you.';
        if (!this.hasAttribute('data-running') || !this.hasAttribute('data-puppet-ready') || !this.character.animate) return;
        this.stopReaction();
        const arm = this.querySelector('.gm-buddy-home__layer--arm');
        const actor = this.querySelector('.gm-buddy-home__actor');
        this.activeAnimations.push(arm.animate([0,-12,18,-15,16,0].map(value => ({transform:`rotate(${value}deg)`})), {duration:1400,easing:'ease-in-out'}));
        this.activeAnimations.push(actor.animate([0,-10,0].map(value => ({transform:`translateY(${value}px)`})), {duration:650,easing:'ease-in-out'}));
      }, {signal});
      this.reduced.addEventListener('change', this.refresh, {signal});
      document.addEventListener('visibilitychange', this.refresh, {signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.refresh(); });
        this.observer.observe(this);
      }
      this.refresh();
    }
    stopReaction() {
      this.activeAnimations.forEach(animation => animation.cancel());
      this.activeAnimations = [];
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.stopReaction();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymatics-scroll-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gymatics-scroll-bar')) {
  customElements.define('gymatics-scroll-bar', class extends HTMLElement {
    connectedCallback() {
      this.frame = 0;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.bar = this.querySelector('[data-page-dock-bar]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      ['scroll','resize'].forEach(name => window.addEventListener(name, this.schedule, {passive:true,signal}));
      ['focusin','focusout'].forEach(name => document.addEventListener(name, this.schedule, {signal}));
      window.visualViewport?.addEventListener('resize', this.schedule, {passive:true,signal});
      this.querySelector('[data-page-dock-top]').addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo({top:0,behavior:this.motion.matches ? 'instant' : 'smooth'});
        const logo = document.querySelector('.gymatics-header-section .header__heading-link');
        logo?.focus({preventScroll:true});
      }, {signal});
      this.changes = new MutationObserver(this.schedule);
      this.changes.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden','data-open']});
      this.size = new ResizeObserver(this.schedule);
      this.size.observe(this.bar);
      this.update();
    }
    update() {
      const typing = document.activeElement?.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]),textarea,select,[contenteditable="true"]');
      const overlays = [...document.querySelectorAll('dialog[open],cart-drawer.active,.menu-drawer-container[open],.sticky-atc-bar.atc-visible,[data-buddy-version][data-open="true"]')];
      const blocked = overlays.some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const viewport = window.visualViewport;
      const keyboard = viewport && window.innerHeight - viewport.height - viewport.offsetTop > 130;
      const visible = window.scrollY > 500 && !typing && !blocked && !keyboard;
      this.bar.hidden = !visible;
      const height = visible ? Math.ceil(this.bar.getBoundingClientRect().height) : 0;
      if (height) this.style.setProperty('--gm-dock-space', height+'px');
      document.documentElement.style.setProperty('--gm-page-dock-height', height+'px');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.changes?.disconnect();
      this.size?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      document.documentElement.style.removeProperty('--gm-page-dock-height');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* Read per-section settings from HTML; Liquid is not evaluated in javascript tags. */
(() => {
  const instances = new WeakMap();
  function init(section) {
    if (!section || instances.has(section)) return;
    const controller = new AbortController();
    instances.set(section, controller);
    const signal = controller.signal;
    const nav = section.querySelector('[data-gymatics-navigation]');
    if (!nav) return;
    const menus = [...nav.querySelectorAll('[data-gymatics-mega]')];
    const desktop = matchMedia('(min-width: 1100px)');
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    const timers = new Map();
    const clear = menu => { clearTimeout(timers.get(menu)); timers.delete(menu); };
    const close = menu => { clear(menu); menu.open = false; menu.querySelector('summary').setAttribute('aria-expanded', 'false'); };
    const open = menu => { menus.forEach(other => { if (other !== menu) close(other); }); clear(menu); menu.open = true; };
    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      summary.setAttribute('aria-expanded', String(menu.open));
      summary.addEventListener('click', () => { menus.forEach(other => { if (other !== menu) close(other); }); }, {signal});
      menu.addEventListener('toggle', () => { summary.setAttribute('aria-expanded', String(menu.open)); }, {signal});
      menu.addEventListener('pointerenter', event => {
        if (nav.dataset.openMode === 'hover' && desktop.matches && hover.matches && event.pointerType !== 'touch') open(menu);
      }, {signal});
      menu.addEventListener('pointerleave', () => {
        if (nav.dataset.openMode !== 'hover' || !hover.matches) return;
        clear(menu); timers.set(menu, setTimeout(() => { if (!menu.contains(document.activeElement)) close(menu); }, 220));
      }, {signal});
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (menu.isConnected && !menu.contains(document.activeElement) && !menu.matches(':hover')) close(menu); }, 0);
      }, {signal});
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      menus.forEach(menu => { if (menu.open) { const focused = menu.contains(document.activeElement); close(menu); if (focused) menu.querySelector('summary').focus(); } });
    }, {signal});
    document.addEventListener('click', event => { menus.forEach(menu => { if (menu.open && !menu.contains(event.target)) close(menu); }); }, {signal});
    desktop.addEventListener('change', () => {
      menus.forEach(close);
      const drawer = section.querySelector('header-drawer');
      if (desktop.matches && !section.querySelector('.drawer-menu') && drawer?.mainDetailsToggle?.open) drawer.closeMenuDrawer(null, drawer.mainDetailsToggle.querySelector('summary'));
    }, {signal});
    signal.addEventListener('abort', () => timers.forEach(clearTimeout), {once:true});
  }
  const initAll = () => document.querySelectorAll('.gymatics-header-section').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once:true}); else initAll();
  document.addEventListener('shopify:section:load', event => { if (event.target.matches('.gymatics-header-section')) init(event.target); });
  document.addEventListener('shopify:section:unload', event => { instances.get(event.target)?.abort(); instances.delete(event.target); });
})();

/* ============================================================
   Gymatics® predictive search
   Uses Shopify's public predictive-search JSON endpoint.
   Enhances both the premium header search and the native mobile
   search modal. No product data is hard-coded.
   ============================================================ */
(() => {
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 170;
  const initializedInputs = new WeakSet();

  const svgPlaceholder = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('gymatics-predictive-search__placeholder');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('d', 'M4 5.75A1.75 1.75 0 0 1 5.75 4h12.5A1.75 1.75 0 0 1 20 5.75v12.5A1.75 1.75 0 0 1 18.25 20H5.75A1.75 1.75 0 0 1 4 18.25V5.75Zm2 .25v9.1l3.3-3.3a1 1 0 0 1 1.4 0l1.8 1.8 2.8-2.8a1 1 0 0 1 1.4 0L18 12.1V6H6Zm12 8.9-2-2-2.8 2.8a1 1 0 0 1-1.4 0L10 13.9l-4 4V18h12v-3.1Z');
    svg.appendChild(path);
    return svg;
  };

  const create = (tag, className, textValue) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (textValue !== undefined && textValue !== null) element.textContent = textValue;
    return element;
  };

  const getImageUrl = item => {
    const image = item?.featured_image || item?.image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  };

  const formatPrice = value => {
    if (value === undefined || value === null || value === '') return '';
    if (typeof value === 'string' && /[^0-9.,\s]/.test(value)) return value;
    const parsed = Number(String(value).replace(',', '.'));
    if (!Number.isFinite(parsed)) return String(value);
    const currency = window.Shopify?.currency?.active;
    if (!currency) return String(value);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency,
        minimumFractionDigits: parsed % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(parsed);
    } catch (_) {
      return String(value);
    }
  };

  const viewAllUrl = (form, query) => {
    try {
      const url = new URL(form.action, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url.toString();
    } catch (_) {
      return `/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`;
    }
  };

  const makePanel = form => {
    const existing = form.parentElement?.querySelector(':scope > [data-gymatics-predictive-panel]');
    if (existing) return existing;

    const panel = create('div', 'gymatics-predictive-search');
    panel.dataset.gymaticsPredictivePanel = '';
    panel.hidden = true;

    const status = create('div', 'gymatics-predictive-search__status');
    status.dataset.gymaticsSearchStatus = '';
    status.setAttribute('aria-live', 'polite');

    const content = create('div', 'gymatics-predictive-search__content');
    content.dataset.gymaticsSearchContent = '';

    panel.append(status, content);
    form.appendChild(panel);
    return panel;
  };

  /*
   * Mobile keyboard safety:
   * iOS Safari's on-screen keyboard covers part of the layout viewport.
   * visualViewport reports the actually visible area, so constrain the
   * results panel to the exact space between the search bar and keyboard.
   */
  const fitPanelToVisibleViewport = (input, panel) => {
    const content = panel?.querySelector('[data-gymatics-search-content]');
    if (!content) return;

    if (!window.matchMedia('(max-width: 749px)').matches) {
      content.style.removeProperty('max-height');
      return;
    }

    const viewport = window.visualViewport;
    const visibleBottom = viewport
      ? viewport.offsetTop + viewport.height
      : window.innerHeight;
    const panelTop = panel.getBoundingClientRect().top;
    const available = Math.floor(visibleBottom - panelTop - 10);

    /* Never let the list run underneath the software keyboard. */
    if (available > 0) {
      content.style.maxHeight = `${Math.max(0, available)}px`;
    }
  };

  const setOpen = (input, panel, open) => {
    panel.hidden = !open;
    input.setAttribute('aria-expanded', String(open));
    if (open) {
      panel.classList.remove('is-opening');
      void panel.offsetWidth;
      panel.classList.add('is-opening');
      requestAnimationFrame(() => fitPanelToVisibleViewport(input, panel));
    } else {
      panel.classList.remove('is-opening');
      const content = panel.querySelector('[data-gymatics-search-content]');
      content?.style.removeProperty('max-height');
    }
  };

  const announce = (panel, message) => {
    const status = panel.querySelector('[data-gymatics-search-status]');
    if (status) status.textContent = message;
  };

  const renderLoading = (input, panel) => {
    const content = panel.querySelector('[data-gymatics-search-content]');
    if (!content) return;
    content.replaceChildren();
    const wrap = create('div', 'gymatics-predictive-search__loading');
    wrap.append(
      create('div', 'gymatics-predictive-search__spinner'),
      create('strong', '', ((window.GymaticsSearchText || {}).finding || "Finding the best matches…")),
      create('span', '', ((window.GymaticsSearchText || {}).searchingShop || "Searching Gymatics®"))
    );
    content.appendChild(wrap);
    announce(panel, ((window.GymaticsSearchText || {}).searching || "Searching"));
    setOpen(input, panel, true);
  };

  const resultLinkAttrs = link => {
    link.dataset.gymaticsResultLink = '';
    link.setAttribute('role', 'option');
    link.setAttribute('tabindex', '-1');
    return link;
  };

  const renderResults = (form, input, panel, query, results) => {
    const content = panel.querySelector('[data-gymatics-search-content]');
    if (!content) return;
    content.replaceChildren();

    const products = Array.isArray(results.products) ? results.products.slice(0, 6) : [];
    const extras = [
      ...(Array.isArray(results.collections) ? results.collections.map(item => ({...item, _type: ((window.GymaticsSearchText || {}).collection || "Collection")})) : []),
      ...(Array.isArray(results.pages) ? results.pages.map(item => ({...item, _type: ((window.GymaticsSearchText || {}).page || "Page")})) : []),
      ...(Array.isArray(results.articles) ? results.articles.map(item => ({...item, _type: ((window.GymaticsSearchText || {}).article || "Article")})) : [])
    ].slice(0, 6);

    const total = products.length + extras.length;
    if (!total) {
      const empty = create('div', 'gymatics-predictive-search__empty');
      empty.append(
        create('strong', '', ((window.GymaticsSearchText || {}).noMatches || "No matches for “[query]”").replace('[query]', query)),
        create('span', '', ((window.GymaticsSearchText || {}).tryAgain || "Try a product name, collection or another keyword."))
      );
      content.appendChild(empty);
      announce(panel, ((window.GymaticsSearchText || {}).noResults || "No results found for [query]").replace('[query]', query));
      setOpen(input, panel, true);
      return;
    }

    const top = create('div', 'gymatics-predictive-search__topline');
    top.append(
      create('p', 'gymatics-predictive-search__eyebrow', products.length ? ((window.GymaticsSearchText || {}).products || "Products") : ((window.GymaticsSearchText || {}).matches || "Matches")),
      create('span', 'gymatics-predictive-search__query', `“${query}”`)
    );
    content.appendChild(top);

    if (products.length) {
      const productList = create('div', 'gymatics-predictive-search__products');
      products.forEach(product => {
        const link = resultLinkAttrs(create('a', 'gymatics-predictive-search__product'));
        link.href = product.url || '#';

        const imageWrap = create('span', 'gymatics-predictive-search__image-wrap');
        const imageUrl = getImageUrl(product);
        if (imageUrl) {
          const img = create('img', 'gymatics-predictive-search__image');
          img.src = imageUrl;
          img.alt = product.featured_image?.alt || product.title || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          imageWrap.appendChild(img);
        } else {
          imageWrap.appendChild(svgPlaceholder());
        }

        const copy = create('span', 'gymatics-predictive-search__product-copy');
        copy.appendChild(create('span', 'gymatics-predictive-search__product-title', product.title || ((window.GymaticsSearchText || {}).product || "Product")));
        const vendor = product.vendor || product.type || 'Gymatics®';
        copy.appendChild(create('span', 'gymatics-predictive-search__product-meta', vendor));

        const price = create('span', 'gymatics-predictive-search__price', formatPrice(product.price));
        link.append(imageWrap, copy, price);
        productList.appendChild(link);
      });
      content.appendChild(productList);
    }

    if (extras.length) {
      const extraBlock = create('div', 'gymatics-predictive-search__extras');
      extraBlock.appendChild(create('p', 'gymatics-predictive-search__extras-title', ((window.GymaticsSearchText || {}).exploreMore || "Explore more")));
      const chips = create('div', 'gymatics-predictive-search__chips');
      extras.forEach(item => {
        const link = resultLinkAttrs(create('a', 'gymatics-predictive-search__chip'));
        link.href = item.url || '#';
        link.append(
          create('span', 'gymatics-predictive-search__chip-type', item._type),
          create('span', '', item.title || item._type)
        );
        chips.appendChild(link);
      });
      extraBlock.appendChild(chips);
      content.appendChild(extraBlock);
    }

    const footer = create('div', 'gymatics-predictive-search__footer');
    const all = resultLinkAttrs(create('a', 'gymatics-predictive-search__view-all'));
    all.href = viewAllUrl(form, query);
    all.append(
      create('span', '', ((window.GymaticsSearchText || {}).viewAll || "View all products for “[query]”").replace('[query]', query)),
      create('span', 'gymatics-predictive-search__arrow', '→')
    );
    footer.appendChild(all);
    content.appendChild(footer);

    announce(panel, `${total} suggestions found for ${query}`);
    setOpen(input, panel, true);
  };

  const initInput = (input, existingPanel) => {
    if (!input || initializedInputs.has(input)) return;
    const form = input.closest('form');
    if (!form) return;
    initializedInputs.add(input);

    const panel = existingPanel || makePanel(form);
    const panelId = panel.id || `GymaticsPredictive-${Math.random().toString(36).slice(2, 9)}`;
    panel.id = panelId;
    input.setAttribute('aria-controls', panelId);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('role', 'combobox');

    let timer;
    let requestController;
    let lastQuery = '';

    const refit = () => {
      if (!panel.hidden) requestAnimationFrame(() => fitPanelToVisibleViewport(input, panel));
    };

    /* visualViewport resize fires when iOS/Android keyboards open/close. */
    window.visualViewport?.addEventListener('resize', refit, { passive: true });
    window.visualViewport?.addEventListener('scroll', refit, { passive: true });
    window.addEventListener('resize', refit, { passive: true });

    const close = () => {
      requestController?.abort();
      clearTimeout(timer);
      setOpen(input, panel, false);
    };

    const search = async rawQuery => {
      const query = rawQuery.trim();
      if (query.length < MIN_CHARS) {
        close();
        return;
      }
      lastQuery = query;
      requestController?.abort();
      requestController = new AbortController();
      renderLoading(input, panel);

      const root = window.Shopify?.routes?.root || '/';
      const params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product,collection,page,article');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');

      try {
        const response = await fetch(`${root}search/suggest.json?${params.toString()}`, {
          headers: { Accept: 'application/json' },
          signal: requestController.signal
        });
        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
        const payload = await response.json();
        if (input.value.trim() !== lastQuery) return;
        renderResults(form, input, panel, query, payload?.resources?.results || {});
      } catch (error) {
        if (error?.name === 'AbortError') return;
        const content = panel.querySelector('[data-gymatics-search-content]');
        if (!content) return;
        content.replaceChildren();
        const empty = create('div', 'gymatics-predictive-search__empty');
        empty.append(
          create('strong', '', 'Search is still available'),
          create('span', '', 'Press Enter or tap Search to see all products.')
        );
        content.appendChild(empty);
        announce(panel, 'Live suggestions are temporarily unavailable');
        setOpen(input, panel, true);
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value;
      if (query.trim().length < MIN_CHARS) {
        close();
        return;
      }
      timer = setTimeout(() => search(query), DEBOUNCE_MS);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= MIN_CHARS && panel.querySelector('[data-gymatics-result-link]')) {
        setOpen(input, panel, true);
      }
      /* Safari animates the keyboard, so fit once immediately and again after it settles. */
      refit();
      setTimeout(refit, 80);
      setTimeout(refit, 260);
    });

    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key === 'ArrowDown' && !panel.hidden) {
        const first = panel.querySelector('[data-gymatics-result-link]');
        if (first) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    panel.addEventListener('keydown', event => {
      const links = [...panel.querySelectorAll('[data-gymatics-result-link]')];
      if (!links.length) return;
      const current = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        links[(current + 1 + links.length) % links.length].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (current <= 0) input.focus();
        else links[current - 1].focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close();
        input.focus();
      }
    });

    form.addEventListener('submit', () => close());

    document.addEventListener('pointerdown', event => {
      if (!form.contains(event.target) && !panel.contains(event.target)) close();
    }, {passive: true});
  };

  const initAll = root => {
    const scope = root || document;

    scope.querySelectorAll('.gymatics-search-experience').forEach(container => {
      const input = container.querySelector('input[type="search"][name="q"]');
      const panel = container.querySelector('[data-gymatics-predictive-panel]');
      initInput(input, panel);
    });

    scope.querySelectorAll('.gymatics-mobile-search input[type="search"][name="q"]').forEach(input => {
      initInput(input, null);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), {once: true});
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header =
        document.querySelector(
          '.section-header'
        );
      if (!this.header) {
        return;
      }
      this.headerIsAlwaysSticky =
        this.getAttribute(
          'data-sticky-type'
        ) === 'always'
        ||
        this.getAttribute(
          'data-sticky-type'
        ) === 'reduce-logo-size';
      this.headerBounds = {top: 0, bottom: this.header.offsetHeight};
      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this.header);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }
      this.currentScrollTop = window.scrollY;
      this.preventReveal =
        false;
      this.onScrollHandler =
        this.onScroll.bind(this);
      this.hideHeaderOnScrollUp =
        () => {
          this.preventReveal =
            true;
        };
      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );
      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );
      this.createObserver();
    }
    setHeaderHeight() {
      if (!this.header) {
        return;
      }
      document.documentElement
        .style
        .setProperty(
          '--header-height',
          `${this.header.offsetHeight}px`
        );
      if (this.headerBounds) this.headerBounds.bottom = this.headerBounds.top + this.header.offsetHeight;
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.boundsObserver?.disconnect();
      clearTimeout(this.isScrolling);
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );
      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }
    createObserver() {
      let observer =
        new IntersectionObserver(
          (entries, observer) => {
            // Copy into a plain object: intersectionRect is read-only and setHeaderHeight() updates bottom.
            const rect = entries[0].intersectionRect;
            this.headerBounds = { top: rect.top, bottom: rect.bottom };
            observer.disconnect();
          }
        );
      this.boundsObserver = observer;
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop =
        window.pageYOffset
        ||
        document.documentElement.scrollTop;
      if (this.header.contains(document.activeElement) || this.header.querySelector('details[open]')) { this.currentScrollTop = scrollTop; return; }
      if (
        scrollTop >
          this.currentScrollTop
        &&
        scrollTop >
          this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );
        if (this.preventHide) {
          return;
        }
        requestAnimationFrame(
          this.hide.bind(this)
        );
      }
      else if (
        scrollTop <
          this.currentScrollTop
        &&
        scrollTop >
          this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );
        if (!this.preventReveal) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        }
        else {
          window.clearTimeout(
            this.isScrolling
          );
          this.isScrolling =
            setTimeout(
              () => {
                this.preventReveal =
                  false;
              },
              66
            );
          requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      }
      else if (
        scrollTop <=
          this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );
        requestAnimationFrame(
          this.reset.bind(this)
        );
      }
      this.currentScrollTop =
        scrollTop;
    }
    hide() {
      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }
      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );
      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }
    reset() {
      if (
        this.headerIsAlwaysSticky
      ) {
        return;
      }
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
    closeMenuDisclosure() {
      const megaMenus =
        this.header.querySelectorAll(
          '[data-gymatics-mega]'
        );
      megaMenus.forEach(
        function (details) {
          details.removeAttribute(
            'open'
          );
        }
      );
    }
    closeSearchModal() {
      this.searchModal =
        this.searchModal
        ||
        this.header.querySelector(
          'details-modal'
        );
      if (
        this.searchModal
        &&
        typeof this.searchModal.close
          === 'function'
      ) {
        this.searchModal.close(
          false
        );
      }
    }
  }
  if (
    !customElements.get(
      'sticky-header'
    )
  ) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
